import styled from 'styled-components';
import theme from '@/data/theme';

interface InputProps {
  $error?: boolean;
}
const StyledAdminLoginFormLabel = styled.label`
  color: ${theme.colors.black};
`;

const StyledAdminLoginFormInput = styled.input<InputProps>`
  border: 1px solid ${({ $error }) => ($error ? '#ff4d4f' : '#edeef1')};
  padding: 16px;
  width: 100%;
  border-radius: 5px;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ $error }) => ($error ? '#ff4d4f' : 'none')};
  }
`;

const StyedInputFieldWrapper = styled.div`
  position: relative;
  height: fit-content;
`;

const StyledAuthPasswordVisibilityToggle = styled.div`
  display: inline-flex;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export {
  StyledAdminLoginFormInput,
  StyledAdminLoginFormLabel,
  StyedInputFieldWrapper,
  StyledAuthPasswordVisibilityToggle,
};
